<template>
  <div class="sclb_wrap">
    <div class="collect_list">
      <div
        class="collect_item"
        v-for="(item, index) in computedStockHoldList"
        :key="index"
      >
        <div class="stock_left">
          <div class="stock_box">
            <div class="stock">{{ item.stockName }}/{{ item.stockCode }}</div>

            <div class="time">{{ item.buyTime }}</div>

            <div class="price">
              {{
                item.strategyStatus == 0
                  ? `建议买入价格：${COMMON.formatToFixed(item.buyPrice)}`
                  : item.strategyStatus == 1 || item.strategyStatus == 2
                  ? `建议卖出价格：${COMMON.formatToFixed(item.sellPrice)}`
                  : ""
              }}
            </div>

            <div class="zyzs_box">
              <div class="zyzs" v-if="item.strategyStatus == 0">
                <div>止盈：{{ COMMON.formatToFixed(item.stopProfitPrice) }}</div>

                <div>止损：{{ COMMON.formatToFixed(item.stopLossPrice) }}</div>
              </div>

              <div
                class="zyzs"
                v-else-if="item.strategyStatus == 1 || item.strategyStatus == 2"
              >
                {{
                  [1, 2].includes(item.strategyStatus)
                    ? `已达${item.strategyStatus == 1 ? "止盈" : "止损"}`
                    : ""
                }}
              </div>
            </div>
          </div>

          <div class="inform_box">
            通知：<span class="time">{{ item.noticeList[0].createTime }}</span
            ><span class="content">{{ item.noticeList[0].content }}</span
            ><span class="btn" @click="msgDetailsClick(item)"
              >点击查看详情</span
            >
          </div>
        </div>

        <div class="stock_right">
          <div class="profit">
            {{ item.strategyStatus == 0 ? "浮动盈亏率:" : "实现利润:" }}
            <span :class="{ sp: item.profitLoss < 0 }">
              {{ item.profitLoss >= 0 ? "+" : ""
              }}{{ COMMON.formatToFixed(item.profitLoss) }}%
            </span>
          </div>

          <div class="collect" @click="collectClick(item, index)">
            <el-icon :size="20" :color="item.collected == 1 ? '#F1F90C' : ''"
              ><StarFilled
            /></el-icon>
            <span>收藏</span>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination_box">
      <el-pagination
        size="small"
        background
        v-model:current-page="pageNum"
        v-model:page-size="pageSize"
        layout="prev, pager, next"
        :total="collectList.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";

export default {
  props: {
    infoList: {},
    userInfo: {},
    pushStockList: {
      type: Array,
      default: () => [
        // { stockCode: 600231, price: 16.55 }
      ],
    },
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 8,
      collectList: {},
      pushedStockData: this.pushStockList,
    };
  },
  computed: {
    computedStockHoldList() {
      const rows = this.collectList.rows || [];
      return rows.map((item) => {
        const pushedItem = this.pushedStockData.find(
          (pushed) => pushed.stockCode === item.stockCode
        );
        const currentPrice = pushedItem?.price ?? item.currentPrice;
        const profitLoss =
          item.strategyStatus == 0
            ? ((currentPrice - item.buyPrice) / item.buyPrice) * 100 // 未卖出：用 现价计算
            : ((item.sellPrice - item.buyPrice) / item.buyPrice) * 100; // 已卖出：用 卖价计算
        return {
          ...item,
          currentPrice,
          collected: 1,
          profitLoss: profitLoss,
        };
      });
    },
  },
  created() {
    this.getCollectList(); // 获取 收藏列表 list
  },
  mounted() {},
  methods: {
    // 获取 收藏列表 list
    getCollectList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/collect/list", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data;
          // console.log(datas);

          if (datas) {
            this.collectList = datas;
          }
        }
      );
    },

    // 分页 页码切换
    handleCurrentChange() {
      this.getCollectList(); // 获取 收藏列表 list

      this.$emit("smoothFixedHeight"); // 父页面 平滑 滚到到顶部
    },

    // 查看消息详情
    msgDetailsClick(item) {
      // console.log(item);

      let title = item.noticeList[0].title;
      this.$emit("skipNotice", title);
    },

    // 收藏/取消收藏
    collectClick(item, index) {
      let action = item.collected == 0 ? "收藏" : "取消收藏";
      let url =
        item.collected == 0
          ? "quant/api/ai-strategy/collect/into"
          : "quant/api/ai-strategy/collect/cancel";

      let data = {
        userNo: this.userInfo.userNo,
        strategyId: this.infoList.id,
        stockId: item.id,
      };

      this.API.CLOUDPost1(url, data).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          ElMessage.success(`${action}成功`);

          this.computedStockHoldList[index].collected =
            item.collected == 0 ? 1 : 0;
          this.$forceUpdate();
        } else {
          ElMessage.error(`${action}失败，请重试`);
        }
      });
    },
  },
  watch: {
    pushStockList(newVal) {
      // console.log(newVal);
      this.pushedStockData = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
.sclb_wrap {
  .collect_list {
    min-height: 500px;
    font-size: 14px;

    .collect_item {
      margin-top: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .stock_left {
        .stock_box {
          display: flex;

          .stock {
            width: 125px;
          }

          .time {
            margin-left: 24px;
          }

          .type {
            width: 100px;
            text-align: center;
            margin-left: 24px;
          }

          .price {
            width: 181px;
            margin-left: 24px;
          }

          .zyzs_box {
            margin-left: 24px;

            .zyzs {
              display: flex;

              div {
                margin-left: 24px;

                &:first-child {
                  margin-left: 0;
                }
              }
            }
          }
        }

        .inform_box {
          margin-top: 10px;
          font-weight: bold;
          display: flex;
          align-items: center;

          .time {
            font-weight: 400;
          }

          .content {
            margin-left: 4px;
            width: 500px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .btn {
            cursor: pointer;
          }
        }
      }

      .stock_right {
        display: flex;
        align-items: center;

        .profit {
          width: 180px;

          span {
            color: #ff0000;

            &.sp {
              color: #26a374;
            }
          }
        }

        .collect {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
        }
      }
    }
  }

  .pagination_box {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>